const OPACITY_STEP = 0.06;
const MIN_OPACITY = 0.4;

export const fadeDownOpacity = (index: number, step = OPACITY_STEP) =>
  Math.max(MIN_OPACITY, 1 - index * step);
